import state from '@/store/modules/auctions/defaultState';

const actions = {
  async getMyAcvNegotiationsSellingAuctions(
    {
      dispatch,
    },
    { page = 1 },
  ) {
    const auctions = await dispatch('auctions/getAuctionList', {
      apiMethod: 'getMyAcvNegotiationsSellingAuctions',
      moduleKey: 'MyAcvNegotiationsSelling',
      numberOfLoaders: 10,
      page,
    }, {
      root: true,
    });
    return auctions;
  },
};

export default {
  state,
  actions,
};
